import React from "react";

type Props = {
	text: string;
}

const SearchHeading = ({ text }: Props) => (
	<div className="searchHeading-wrapper">
		<h3 className="resultsHeading">
			{text}
		</h3>
	</div>
);

export default SearchHeading;
